export default {
    mfaLogin: {
        heading: "雙重認證登入",
        error: "發生問題，請重新整理後再試一次。如果問題仍然持續，請電郵至 <a href=\"mailto:support@edcity.hk\" target=\"_top\">support@edcity.hk</a>。 ",
        error04: "由於你未能於限時內完成雙重認證，請重新登入。",
        error07: "此電郵地址不能用於雙重認證登入。",
        mfaEmailTitle: "學校管理員啟用雙重認證登入",
        mfaEmailSubtitle: "請提供電郵地址以啟用雙重認證。確認電郵將會發送到您輸入的電郵地址。<br>1. 可沿用學校管理員的登入電郵作雙重認證登入。<br>2. 請勿使用其他教城帳戶的登入電郵作學校管理員的雙重認證登入 。",
        mfaEmailRemind: "確認電郵已經發送到您早前輸入的電郵地址，請點按此處繼續驗證流程。 ",
        mfaEmailRemindSubtitle: "如您沒有收到確認電郵或需作出其他更改，請重新填寫。",
        loginEmail: "登入電郵",
        loginEmailError: "登入電郵格式不正確",
        loginEmailHint: "以此電郵將用於驗證教城帳戶登入電郵作為雙重認證登入",
        loginEmailUnaccepted: "此電郵不能作為登記用戶，請使用其他電郵。",
        loginEmailInUse: "電郵地址已用於其他教城帳戶。請使用其他電郵地址。",
        loginEmailPending: "此電郵地址已被登記，並正等待啟用。",
        alreadyVerifiedAsTeacher: "電郵地址已用於其他教城個人教師帳戶。請使用其他電郵地址。",
        completed: "驗證帳戶的電郵已發送至 <span class='orangeText'>{loginEmail}</span> 。請於 {expireAt} 或之前點按電郵中的連結以完成雙重認證；並請於完成驗證後按「已完成驗證」以繼續登入。",
        hold: "24小時内已嘗試提交錯誤雙重認證登入5次，請在{displayDatetime}之後再嘗試。",
        wait: "學校管理員的雙重認證尚未完成，請點按確認電郵中的連結完成認證。 ",
    },
    mfaLoginEmailVerification: {
        heading: "已成功驗證",
        mainMessage: "確認更新帳戶登入電郵並作為雙重認證登入之用",
        success: "您已經成功更新登入電郵及設定學校管理員雙重認證至{email}。 ",
    },
    otpLogin: {
        heading: "一次性密碼登入",
        error: "登入電郵/登入名稱無效",
        error01: "發生問題，請重新整理後再試一次。如果問題仍然持續，請電郵至 <a href=\"mailto:support@edcity.hk\" target=\"_top\">support@edcity.hk</a>。",
        error04: "由於你未能於限時內完成一次性密碼登入，請重新登入。",
        errorSchoolAdmin: "(學校管理員請使用密碼登入)",
        loginEmail: "登入電郵/登入名稱",
        loginEmailError: "登入電郵/登入名稱格式錯誤",
        otpEmailTitle: "使用一次性密碼登入",
        otpEmailSubtitle: "一次性密碼將發送至您的登入電子郵件。",
        hold:"24小時内已嘗試提交錯誤一次性密碼登入5次，請在{displayDatetime}之後再嘗試，或以密碼重新登入。",
    },
    button: {
        back: "重新登入",
        submit: "提交",
        verified: "已完成驗證",
        login: "登入",
        send: "發送",
        resend: "重新發送",
        close: "返回",
        more: " ...更多",
    },
    text: {
        loginTitle: "輸入一次性密碼",
        loginSubtitle: "請輸入發送到您登入電郵 <span class='orangeText'>{loginEmail}</span> 的一次性密碼。如果您無法收到一次性密碼，請電郵至 <a href=\"mailto:support@edcity.hk\" target=\"_top\">support@edcity.hk</a>。",
        otp: "一次性密碼",
        verifySuccess: "驗證成功",
        countdown: "一次性密碼有效時間：",
        codeExpired: "一次性密碼已逾時，請按重新發送",
        codeInvalid: "一次性密碼錯誤。",
        codeNotFound:"找不到對應記錄，請返回重新發送。",
    }
}